<template>
  <div>
    <v-container class="col-12 ml-0 mt-10 pl-0">
      <v-row :style="searchHeight" class="mb-4" cols="12">
        <v-col cols="2" :style="searchHeight">
          <v-select
            v-model="searchPayload.range_type"
            :items="reCodeDateList"
            persistent-hint
            :style="searchHeight"
            class="pt-0"
            outlined
            dense
          ></v-select>
        </v-col>
        <v-col cols="4">
          <v-menu
            v-model="startMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="searchPayload.from"
                readonly
                v-on="on"
                dense
                :style="textFileSize"
                class="d-inline-block mr-1"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="searchPayload.from"
              @input="startMenu = false"
              locale="ko"
              :max="searchPayload.to"
            ></v-date-picker>
          </v-menu>~
          <v-menu
            v-model="endMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                outlined
                v-model="searchPayload.to"
                readonly
                v-on="on"
                dense
                :style="textFileSize"
                class="d-inline-block mr-1"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="searchPayload.to"
              @input="endMenu = false"
              locale="ko"
              :min="searchPayload.from"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="2" class="mt-3 pl-0 pr-0">
          <p class="pt-0 mt-0 mb-0">정품 인증 회원ID</p>
        </v-col>
        <v-col cols="4" class="pr-0">
          <v-text-field
            v-model="searchPayload.member_id"
            outlined
            dense
            class="mr-1"
            placeholder="아이디 입력"
            :style="{ width: '92%' }"
            @keypress.enter="execSearch(true)"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row :style="searchHeight" class="mb-4" cols="12">
        <v-col cols="2">
          <v-select
            v-model="searchPayload.search_type"
            :items="codeList"
            label="Select"
            persistent-hint
            single-line
            class="pt-0"
            outlined
            dense
            @change="changeSearchType"
          ></v-select>
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="searchPayload.search_value"
            outlined
            dense
            class="mr-1"
            cols="12"
            :style="{ width: '86%' }"
            :placeholder="searchValuePlaceholder"
            @keypress.enter="execSearch(true)"
          ></v-text-field>
        </v-col>

        <v-col cols="2" class="mt-3 pl-0 pr-0">
          <p class="pt-0 mt-0 mb-0">분실건 인증 시도</p>
        </v-col>
        <v-col cols="4" class="pr-0">
          <v-select
            v-model="searchPayload.lost_trial"
            :items="lostAuthAttemptList"
            label="Select"
            persistent-hint
            single-line
            class="pt-0"
            outlined
            dense
            :style="{ width: '92%' }"
          ></v-select>
        </v-col>
      </v-row>

      <div class="row justify-center mt-5 mb-10">
        <v-btn
          large
          color="grey darken-4 mt-5"
          class="white--text"
          width="100"
          @click.prevent="execSearch(true)"
        >조회</v-btn>
        <v-btn
          large
          color="mt-5"
          style="margin-left: 20px;"
          width="100"
          @click.prevent="resetSearch"
        >초기화</v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";

export default {
  data() {
    return {
      textFileSize: {
        height: "50px",
        width: "110px"
      },
      searchHeight: {
        height: "50px"
      },
      commonSize: {
        height: "50px"
      },
      reCodeDateList: [
        { text: "분실일자", value: "lost_at" },
        { text: "인증일자", value: "activated_at" }
      ],
      codeList: [
        { text: "정품인증코드", value: "serial_number" },
        { text: "상품코드", value: "product_code" },
        { text: "품목코드", value: "variant_code" },
        { text: "자체상품코드", value: "custom_product_code" },
        { text: "자체품목코드", value: "custom_variant_code" }
      ],
      lostAuthAttemptList: [
        { text: "전체", value: "" },
        { text: "있음", value: "Y" },
        { text: "없음", value: "N" }
      ],
      startMenu: false,
      endMenu: false,
      searchValuePlaceholder: "정품인증코드 - 없이 입력 가능",
      searchPayload: {
        product_name: "",
        search_type: "serial_number",
        search_value: "",
        range_type: "lost_at",
        from: "",
        to: "",
        member_id: "",
        lost_trial: "",
        limit: 20,
        offset: 0
      }
    };
  },
  mixins: [CommonMixin],
  created: function() {
    this.eventHub.$on("execSearch", this.execSearch);
  },
  methods: {
    /**
     * 검색
     */
    execSearch: function(init = false) {
      this.$nextTick(function() {
        if (init === true) {
          this.$parent.$refs.lostListComponent.options = {
            page: 1,
            itemsPerPage: this.searchPayload.limit
          };
        } else {
          let {
            page,
            itemsPerPage
          } = this.$parent.$refs.lostListComponent.options;
          this.searchPayload.offset = (page - 1) * itemsPerPage;
          this.searchPayload.limit = itemsPerPage;
          this.getProductList(this.searchPayload);
        }
      });
    },
    resetSearch: function() {
      this.searchPayload = {
        product_name: "",
        search_type: "serial_number",
        search_value: "",
        range_type: "lost_at",
        from: "",
        to: "",
        member_id: "",
        lost_trial: "",
        limit: 20,
        offset: 0
      };
      this.setInitDate();
    },
    /**
     * 상품 가져오기
     */
    getProductList: async function(payload) {
      this.$parent.$refs.lostListComponent.tableLoading = true;
      try {
        let data = await M.api(M.entry("/lost/search"), payload);
        this.eventHub.$emit("setLostList", data);
      } catch (e) {
        this.$parent.$refs.lostListComponent.tableLoading = false;
        if (e.response.status === 403) {
          this.alertShow(
            "해당 메뉴는 '플러스 버전' 에서 사용이 가능합니다.</br>[결제관리] 메뉴에서 버전을 변경/결제하여 사용해주세요."
          );
        }
      }
    },
    /**
     * 검색어 타입 수정
     **/
    changeSearchType: function() {
      let placeholderData = {
        serial_number: "정품인증코드 - 없이 입력 가능",
        product_code: "상품코드 입력",
        custom_product_code: "자체상품코드 입력",
        variant_code: "품목코드 입력",
        custom_variant_code: "자체품목코드 입력"
      };
      this.searchValuePlaceholder =
        placeholderData[this.searchPayload.search_type];
    },
    setInitDate: function() {
      let toDay = new Date();
      var fromDay = new Date();
      var month = fromDay.getMonth();
      fromDay.setMonth(month - 1);
      this.searchPayload.from = M.yyyymmdd(fromDay);
      this.searchPayload.to = M.yyyymmdd(toDay);
    }
  },
  mounted: function() {
    this.setInitDate();
  }
};
</script>
